// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3iXGv","footer":"Form_footer__2so85"};